/* global Modernizr */

var App = App || {};

App.HamburgerNav = (function ($) {
    "use strict";

    var $body,
        $button,
        $menu;

    function init() {
        $body = $('body');
        $button = $('#hamburger-nav-button');
        $menu = $('#hamburger-nav-menu');

        $button.on('click', function () {
            $body.hasClass('hamburger--open') ? closeMenu() : openMenu();
        });

        $menu.on('click', '.hamburger-nav__level-1-item--has-children > a', function (e) {
            var $this = $(this),
                $parent = $this.parent();

            e.preventDefault();

            $parent.hasClass('hamburger-nav__level-1-item--open') ? closeSubMenu($parent) : openSubMenu($parent);
        });

        App.$window.on('leave-xs', closeMenu);
    }

    function openMenu() {
        $body.addClass('hamburger--open');
        $button.addClass('hamburger-nav__button--open').html('<i class="fa fa-times" aria-hidden="true"></i> Close');
        $menu.addClass('hamburger-nav__menu--open');
    }

    function closeMenu() {
        $body.removeClass('hamburger--open');
        $button.removeClass('hamburger-nav__button--open').html('<i class="fa fa-bars" aria-hidden="true"></i> Open');
        $menu.removeClass('hamburger-nav__menu--open');
    }

    function openSubMenu($item) {
        $item.addClass('hamburger-nav__level-1-item--open');
        $item.find('.hamburger-nav__level-2').stop().slideDown(350);

        $item.siblings('.hamburger-nav__level-1-item--open').each(function () {
            closeSubMenu($(this), false);
        });
    }

    function closeSubMenu($item) {
        $item.removeClass('hamburger-nav__level-1-item--open');
        $item.find('.hamburger-nav__level-2').stop().slideUp(350);
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.HamburgerNav.init();
});